import { render, staticRenderFns } from "./CorrigeOPacDaUgbtComODaUcbt.vue?vue&type=template&id=6b56f35c&"
import script from "./CorrigeOPacDaUgbtComODaUcbt.vue?vue&type=script&lang=js&"
export * from "./CorrigeOPacDaUgbtComODaUcbt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports